module.exports = __webpack_public_path__ + "img/KSAT25-45-1500-2-complete.1e9696c2.png";